import { LogOut } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { SidebarTrigger } from '@/components/ui/sidebar'
import { useToast } from '@/components/ui/use-toast'
import { dataLayerService } from '@/features/analytics'
import { useAppSignOut } from '@/lib/auth/client'

/** The navbar and the sidebar's sign-out buttons say the same thing when Better Auth refuses. */
export const SIGN_OUT_FAILED_TOAST = {
  title: "We couldn't sign you out",
  description: 'Try again. On a shared computer, close the browser.',
  variant: 'destructive',
} as const

/**
 * Mobile-only top bar for the customer dashboard. On desktop the sidebar is
 * always visible (this bar is `md:hidden`); on mobile it hosts the trigger that
 * opens the shadcn sidebar sheet plus a sign-out button. Account settings live
 * on /account/settings, reached from the sidebar.
 */
export function CustomerNavbar() {
  const signOut = useAppSignOut()
  const { toast } = useToast()

  const handleSignOut = async () => {
    try {
      dataLayerService.push('sign_out')
      await signOut()
    } catch (error) {
      console.error('Logout error:', error)
      // On a shared computer the customer must know they are still signed in.
      toast(SIGN_OUT_FAILED_TOAST)
    }
  }

  return (
    <header className="flex h-14 shrink-0 items-center gap-2 border-b border-border px-4 md:hidden">
      <SidebarTrigger className="-ml-1" />
      <div className="flex-1" />
      <Button
        type="button"
        variant="ghost"
        size="icon-sm"
        aria-label="Sign out"
        title="Sign out"
        onClick={() => void handleSignOut()}
      >
        <LogOut className="size-5" />
      </Button>
    </header>
  )
}
